import { Shimmer } from '@components';

import { AssetSidebarContainer } from './Sidebar.styles';

export const SidebarLoading = () => {
  return (
    <AssetSidebarContainer className="loading" data-offsettop={24}>
      <Shimmer
        style={{
          height: '40%',
          width: '100%',
          borderRadius: 4,
          marginBottom: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <Shimmer
        style={{
          height: '55%',
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </AssetSidebarContainer>
  );
};
